import { open } from '../../../components/dropdown_menu_unpoly'

up.compiler('.js-backend_posts_page_state_filter_show_all', function (checkboxShowAll) {
  const checkboxes = document.querySelectorAll('.js-backend_posts_page_state_filter_form input[type=checkbox]')
  const checkboxesArr = Array.from(checkboxes)

  checkboxShowAll.checked = checkboxesArr.every(checkbox => checkbox.checked)

  up.on(checkboxShowAll, 'click', function () {
    if (checkboxShowAll.checked) {
      toggleAll(checkboxes, true)
    } else {
      toggleAll(checkboxes, false)
    }
  })

  checkboxes.forEach(ch => {
    up.on(ch, 'click', function () {
      checkboxShowAll.checked = checkboxesArr.every(checkbox => checkbox.checked)
    })
  })
})

up.compiler('.js-backend_posts_page_distribution_filter_show_all', function (checkboxShowAll) {
  const checkboxes = document.querySelectorAll('.js-backend_posts_page_distribution_filter_form input[type=checkbox]')
  const checkboxesArr = Array.from(checkboxes)

  checkboxShowAll.checked = checkboxesArr.every(checkbox => checkbox.checked)

  up.on(checkboxShowAll, 'click', function () {
    if (checkboxShowAll.checked) {
      toggleAll(checkboxes, true)
    } else {
      toggleAll(checkboxes, false)
    }
  })

  checkboxes.forEach(ch => {
    up.on(ch, 'click', function () {
      checkboxShowAll.checked = checkboxesArr.every(checkbox => checkbox.checked)
    })
  })
})

const toggleAll = function (checkboxes, checked) {
  checkboxes.forEach(ch => {
    ch.checked = checked
  })
}

up.compiler('.js-backend_posts_page_topics_filter_show_all', function (checkboxShowAll) {
  const checkboxes = document.querySelectorAll('.js-backend_posts_page_topics_filter_form input[type=checkbox]')

  const checkboxesArr = Array.from(checkboxes)

  checkboxShowAll.checked = checkboxesArr.every(checkbox => checkbox.checked)

  up.on(checkboxShowAll, 'click', function () {
    if (checkboxShowAll.checked) {
      toggleAll(checkboxes, true)
    } else {
      toggleAll(checkboxes, false)
    }
  })

  checkboxes.forEach(ch => {
    up.on(ch, 'click', function () {
      checkboxShowAll.checked = checkboxesArr.every(checkbox => checkbox.checked)
    })
  })
})

up.on('up:form:submit', '.js-backend_posts_page_state_filter_form', function () {
  localStorage.setItem('stateMenuOpen', 'true')
})

up.on('up:form:submit', '.js-backend_posts_page_distribution_filter_form', function () {
  localStorage.setItem('distributionMenuOpen', 'true')
})

up.on('up:form:submit', '.js-backend_posts_page_state_filter_all_form', function () {
  localStorage.setItem('stateMenuOpen', 'true')
})

up.on('up:form:submit', '.js-backend_posts_page_distribution_filter_all_form', function () {
  localStorage.setItem('distributionMenuOpen', 'true')
})

up.on(
  'up:form:submit',
  '.js-backend_posts_page_topics_filter_all_form, .js-backend_posts_page_topics_filter_form',
  function () {
    localStorage.setItem('topicsMenuOpen', 'true')
  }
)

up.compiler('.js-dropdown_menu.js-backend_posts_page_date_header', function (element) {
  if (localStorage.getItem('stateMenuOpen') === 'true') {
    open(element)
    localStorage.setItem('stateMenuOpen', 'false')
  }
})

up.compiler('.js-dropdown_menu.js-backend_posts_page_distribution_header', function (element) {
  if (localStorage.getItem('distributionMenuOpen') === 'true') {
    open(element)
    localStorage.setItem('distributionMenuOpen', 'false')
  }
})

up.compiler('.js-dropdown_menu.js-backend_posts_page_topics_header', function (element) {
  if (localStorage.getItem('topicsMenuOpen') === 'true') {
    open(element)
    localStorage.setItem('topicsMenuOpen', 'false')
  }
})

up.compiler('.js-backend_posts_page_table', function () {
  return () => {
    localStorage.removeItem('distributionMenuOpen')
    localStorage.removeItem('stateMenuOpen')
  }
})
